import React, { memo, useContext } from 'react'

import { HTMLToReact } from '@vividseats/vivid-ui-kit'

import CmsContext from '@/context/cms'
interface HTMLToReactProps {
    article: string
}

const MemoizedHTMLToReact = memo(function HTMLToReactWrapper({ article }: HTMLToReactProps) {
    return <>{article && <HTMLToReact html={article} />}</>
})

const Article: React.FC = () => {
    const {
        selectors: { article },
    } = useContext(CmsContext)

    return <MemoizedHTMLToReact article={article} />
}

export default Article
